
import React from 'react';
import AppRoutes from './routes';

const App: React.FC = () => {
    return (
        <div>
            <AppRoutes/>
        </div>
    );
};

export default App;
